// Criterio ÚNICO de «¿cuadró la caja?».
//
// 🚨 17-sep-2026: había CUATRO. El panel de caja y la vista general usaban ≤$5 para llamarla
// «diferencia menor»; el modal de conteo pintaba verde SOLO con 0 exacto (y cualquier faltante,
// aunque fuera de $1, en rojo); y el texto del corte por WhatsApp decía «cuadró» con <$0.01.
// El mismo arqueo se describía de tres maneras según dónde lo miraras. Aquí queda uno solo:
//   · 0            → cuadró
//   · |dif| ≤ $5   → diferencia menor (ámbar)
//   · más          → faltante/sobrante de verdad (rojo)
// El backend usa el mismo umbral en routes/letsmove-finances.js (semáforo del Inicio).
export const TOLERANCIA_MENOR = 5;

export type NivelCaja = 'cuadra' | 'menor' | 'grave';

export function nivelDiferencia(n: number): NivelCaja {
  const d = Math.abs(Number(n) || 0);
  if (d < 0.01) return 'cuadra';
  return d <= TOLERANCIA_MENOR ? 'menor' : 'grave';
}

export function colorDiferencia(n: number) {
  switch (nivelDiferencia(n)) {
    case 'cuadra': return 'text-emerald-600 dark:text-emerald-400';
    case 'menor': return 'text-amber-600 dark:text-amber-400';
    default: return 'text-red-600 dark:text-red-400';
  }
}

// ── DENOMINACIONES del conteo de billetes (lista ÚNICA: conteo, «Ver billetes» y su tarjeta) ──
// 1-oct-2026 (audio + captura de Mabel): el $20 existe en BILLETE y en MONEDA y había un solo renglón;
// ahora son dos. La llave del JSON guardado sigue siendo el valor ('20' = billete, como en todo el
// histórico) y la moneda va con sufijo: '20m'. Nada más lee estas llaves que este archivo.
export type Denominacion = { k: string; valor: number; etiqueta: string };
export const DENOMINACIONES: Denominacion[] = [
  { k: '1000', valor: 1000, etiqueta: '$1000' },
  { k: '500', valor: 500, etiqueta: '$500' },
  { k: '200', valor: 200, etiqueta: '$200' },
  { k: '100', valor: 100, etiqueta: '$100' },
  { k: '50', valor: 50, etiqueta: '$50' },
  { k: '20', valor: 20, etiqueta: '$20 billete' },
  { k: '20m', valor: 20, etiqueta: '$20 moneda' },
  { k: '10', valor: 10, etiqueta: '$10' },
  { k: '5', valor: 5, etiqueta: '$5' },
  { k: '2', valor: 2, etiqueta: '$2' },
  { k: '1', valor: 1, etiqueta: '$1' },
  { k: '0.5', valor: 0.5, etiqueta: '$0.5' },
];
const POR_LLAVE = Object.fromEntries(DENOMINACIONES.map((d) => [d.k, d]));
/** Interpreta una llave guardada ('20', '20m', '0.5'…). Una llave desconocida se lee por su número. */
export function denominacion(k: string): Denominacion {
  const d = POR_LLAVE[k] || POR_LLAVE[String(Number(k))];
  if (d) return d;
  const v = parseFloat(k) || 0;
  return { k, valor: v, etiqueta: `$${v % 1 === 0 ? v : v.toFixed(1)}` };
}
/** Renglones con cantidad > 0 de un desglose guardado, en el orden de la lista (de mayor a menor). */
export function filasDesglose(mxn: Record<string, number> | null | undefined) {
  const m = mxn || {};
  const orden = (k: string) => { const i = DENOMINACIONES.findIndex((d) => d.k === k); return i < 0 ? 999 - (parseFloat(k) || 0) : i; };
  return Object.keys(m).filter((k) => Number(m[k]) > 0).sort((a, b) => orden(a) - orden(b))
    // moneda = la de $20 (llave '20m') y todo lo menor de $20; billete = $20 billete y mayores.
    .map((k) => { const d = denominacion(k); const n = Number(m[k]); return { k, etiqueta: d.etiqueta, valor: d.valor, n, total: d.valor * n, moneda: k.endsWith('m') || d.valor < 20 }; });
}
